import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Spin } from 'antd'
import { announce } from './LiveRegionAnnouncer'

// Timing and styling constants
const LOADING_COMPLETE_DELAY_MS = 100 // Delay before announcing loading complete
const SPINNER_Z_INDEX = 9999 // Z-index to ensure spinner appears above other content

const SpinLoader = ({
  position,
  height,
  tip,
  priority = 'assertive',
  announceComplete = true,
  ...props
}) => {
  const loadingText = tip || 'Loading. Please wait...'

  useEffect(() => {
    // Announce when the spinner appears
    announce(loadingText, priority)

    // Optional: announce when loading completes (component unmounts)
    return () => {
      if (announceComplete) {
        // Small delay to avoid conflicts with content loading
        setTimeout(() => {
          announce('Loading complete', 'assertive')
        }, LOADING_COMPLETE_DELAY_MS)
      }
    }
  }, [loadingText, priority, announceComplete])

  return (
    <SpinWrapper
      role="status"
      position={position}
      height={height}
      aria-busy="true"
    >
      <Spin tip={tip} {...props} />
    </SpinWrapper>
  )
}

export default SpinLoader

const SpinWrapper = styled.div`
  position: ${(props) => props.position || 'absolute'};
  height: ${(props) => props.height || '100%'};
  left: 0;
  right: 0;
  top: 0;
  bottom: 0px;
  z-index: ${SPINNER_Z_INDEX};

  .ant-spin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
  }
`
